<template>
  <div id="app">
      <router-view></router-view>
      <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0
    };
  },
  created(){
    localStorage.setItem('lang', 'zh');
    this.$i18n.locale = 'zh';
    this.setDocTitle();
    this.getBaseInfo();
  },
  watch: {
    '$route'() {
      this.setDocTitle();
    },
    '$i18n.locale'() {
      this.setDocTitle();
    }
  },
  methods: {
    setDocTitle(){
      document.title = this.$t('app.brand');
    },
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if(!localStorage.getItem('token') && this.$route.path !== '/Login'){
           this.$router.push({path:'/Login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    }
  }
}
</script>

<style>
body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 500px;
  background: linear-gradient(#1d1610, #3b2818) !important;
}
body .van-toast .van-toast__icon {
  font-size: 50px;
}
/* 通用 Dialog：与项目字号/宽度一致，避免 vant 默认 320px 转 vw 后过小 */
body .app-common-dialog.van-dialog {
  width: 80% !important;
  font-size: 32px;
  border-radius: 16px;
}
body .app-common-dialog .van-dialog__message {
  font-size: 32px;
  line-height: 1.5;
  padding: 48px 36px;
}
body .app-common-dialog .van-button {
  font-size: 32px;
  height: 96px;
  line-height: 96px;
}
*, :after, :before {
  box-sizing: border-box;
}
</style>
